// src/components/HowItWorksSelector.jsx
import React from 'react';

export default function HowItWorksSelector({ language = 'en', onSelect }) {
  const content = {
    en: {
      title: "What do you want to do?",
      owner: {
        title: "I’m the owner",
        desc: "I want to register my items and receive alerts.",
      },
      finder: {
        title: "I found an item",
        desc: "I want to notify the owner and return it.",
      },
    },
    es: {
      title: "¿Qué deseas hacer?",
      owner: {
        title: "Soy el propietario",
        desc: "Quiero registrar mis productos y recibir alertas.",
      },
      finder: {
        title: "Encontré un objeto",
        desc: "Quiero notificar al dueño y devolverlo.",
      },
    },
    pt: {
      title: "O que você deseja fazer?",
      owner: {
        title: "Sou o proprietário",
        desc: "Quero registrar meus itens e receber alertas.",
      },
      finder: {
        title: "Encontrei um objeto",
        desc: "Quero notificar o dono e devolvê-lo.",
      },
    },
  };

  const t = content[language];

  return (
    <section className="bg-white py-16">
      <div className="max-w-[1536px] mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-10">
          {t.title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Card 1: Owner */}
          <button
            onClick={() => onSelect('owner')}
            className="border border-gray-300 rounded-xl p-6 hover:shadow-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-turquoise-400"
          >
            <img
              src="/assets/images/howitworks/owner128.webp"
              alt={t.owner.title}
              className="mx-auto mb-4 w-20"
            />
            <h3 className="text-xl font-semibold text-[#48887B]">
              {t.owner.title}
            </h3>
            <p className="text-gray-600 mt-2">{t.owner.desc}</p>
          </button>

          {/* Card 2: Finder */}
          <button
            onClick={() => onSelect('finder')}
            className="border border-gray-300 rounded-xl p-6 hover:shadow-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-turquoise-400"
          >
            <img
              src="/assets/images/howitworks/found153.webp"
              alt={t.finder.title}
              className="mx-auto mb-4 w-20"
            />
            <h3 className="text-xl font-semibold text-[#48887B]">
              {t.finder.title}
            </h3>
            <p className="text-gray-600 mt-2">{t.finder.desc}</p>
          </button>
        </div>
      </div>
    </section>
  );
}
